import { optionalPositiveInteger, optionalTrimmedString } from '../../../lib/routeSearch';
import { defaultListsFilter, listsPageSizes, type ListsFilter } from './model';

export interface ListsRouteSearch {
  search?: string;
  page?: number;
  size?: number;
}

export function listsRouteSearchSchema(search: Record<string, unknown>): ListsRouteSearch {
  const searchTerm = optionalTrimmedString(search['search']);
  const page = optionalPositiveInteger(search['page']);
  const parsedSize = optionalPositiveInteger(search['size']);
  const size = listsPageSizes.find((value) => value === parsedSize);
  return {
    ...(searchTerm ? { search: searchTerm } : {}),
    ...(page ? { page } : {}),
    ...(size ? { size } : {}),
  };
}

export function parseListsRouteSearch(search: ListsRouteSearch): ListsFilter {
  return {
    searchTerm: search.search ?? defaultListsFilter.searchTerm,
    page: search.page ? search.page - 1 : defaultListsFilter.page,
    size: search.size ?? defaultListsFilter.size,
  };
}

export function serializeListsRouteSearch(filter: ListsFilter): ListsRouteSearch {
  return {
    ...(filter.searchTerm.trim() ? { search: filter.searchTerm.trim() } : {}),
    ...(filter.page ? { page: filter.page + 1 } : {}),
    ...(filter.size !== defaultListsFilter.size ? { size: filter.size } : {}),
  };
}
